import { Component, inject, Input, SimpleChanges, OnInit, OnDestroy } from '@angular/core';
import { IconsService } from '../../../services/icons.service';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AsignaturaItem, grado, GradoItem, asignaturas, DataCore, filterData, temaItem, categoriaItem, aplicacion } from '../../../interface/data-core';
import { environment } from '../../../../environments/environment';
import { IconsAsignaturasService } from '../../../services/icons-asignaturas.service';
import { CargarConfService } from '../../../services/cargar-conf.service';
import { FILTER_LABEL_GRADO, onAddClass, onRemoveClass, toggleClass, openSearch, GRADOS_COMPONENT_ID, onScrollComponente, ASIGNATURA_COMPONENT_ID, agruparAsignaturas, FILTER_LABEL_ASIGNATURA, FILTER_LABEL_CATEGORIA, FILTER_LABEL_CLASS_ASIGNATURA, CAT_LABEL_APLICACION, CAT_LABEL_LECTURA, CAT_LABEL_VIDEO, CAT_LABEL_EVALUACION, CAT_LABEL_SIMULACION, FILTER_LABEL_TEMA } from '../../../utils/generales';
import { Subscription } from 'rxjs';
import { CheckboxModule } from 'primeng/checkbox';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ImageModule } from 'primeng/image';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-filtros',
    imports: [TooltipModule, SelectModule, FormsModule, CommonModule, CheckboxModule, ImageModule],
    templateUrl: './filtros.component.html',
    styleUrl: './filtros.component.css'
})
export class FiltrosComponent implements OnInit, OnDestroy {
    @Input() public dataLocal: DataCore | null = null;
    @Input() public dataGrados?: grado[] = [];
    @Input() public dataAsignaturas?: asignaturas[] = [];
    @Input() public dataAplicaciones: aplicacion[] = [];

    public _icons = inject(IconsService);
    public _icon_asignatura = inject(IconsAsignaturasService);
    private _conf = inject(CargarConfService);
    public selectedCategories: categoriaItem[] = [];
    public tempAplicaciones: aplicacion[] = [];
    // Variables para los selects
    temas_list: temaItem[] = [];
    selectedTema: temaItem | null = null;
    selectedGrado: GradoItem | null = null;
    selectedAsignatura: AsignaturaItem | null = null;
    public searchTerm: string = '';

    // Listas de opciones
    public grados_list: GradoItem[] = [];
    public asignaturas_list: AsignaturaItem[] = [];

    // Suscripción para escuchar cambios en los filtros
    private filtersSubscription: Subscription = new Subscription();
    constructor(private sanitizer: DomSanitizer) { }
    public url_img_app: string = environment.url_img_app;


    public categorias: categoriaItem[] = [
        {
            label: CAT_LABEL_APLICACION, icon: this._icons.aplicacion,
        },
        {
            label: CAT_LABEL_LECTURA, icon: this._icons.lectura,
        },
        {
            label: CAT_LABEL_VIDEO, icon: this._icons.video
        },
        {
            label: CAT_LABEL_EVALUACION, icon: this._icons.evaluacion
        },
        {
            label: CAT_LABEL_SIMULACION, icon: this._icons.simulador
        }
    ];

    public tempCategorias: string[] = [];
    //mostrar solo las categorías dependiendo las categorias filtradas por
    // grado, asignatura y tema
    private filtrarCategorias() {
        const filters = this._conf.getCurrentFilters();
        this.tempCategorias = this._conf.filtrarCategoriasAplicacionesByGRadoAsignaturaTema(
            this.dataLocal?.aplicaciones || [], filters
        );
    }

    onCategoryChange(event: any): void {
        console.debug('Categorías seleccionadas:', this.selectedCategories);
        console.debug('Valor actual del checkbox:', event.value);
        console.debug('¿Está marcado?:', event.checked);

        let listLabels: string[] = this.selectedCategories.map(cat => cat.label);

        this._conf.updateFilterField(
            FILTER_LABEL_CATEGORIA as keyof filterData,
            listLabels
        );
    }

    ngOnInit() {
        this.init();

        // Suscribirse a los cambios de filtros
        this.filtersSubscription = this._conf.filters$.subscribe(filters => {
            this.updateSelectedValues(filters);
        });
    }

    ngOnDestroy() {
        this.filtersSubscription.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.init();
    }

    init() {
        this.onGrados();
        this.onAsignaturas();
        this.getTemas();
        this.filtrarCategorias();
        // Actualizar valores seleccionados después de inicializar las listas
        const currentFilters = this._conf.getCurrentFilters();
        this.updateSelectedValues(currentFilters);
    }

    /**
     * Actualiza los valores seleccionados en los p-select basándose en los filtros actuales
     */
    private updateSelectedValues(filters: filterData) {
        // Actualizar grado seleccionado
        this.selectedGrado = this.grados_list.find(grado => grado.id === filters.grado) || null;

        // Actualizar asignatura seleccionada
        this.selectedAsignatura = this.asignaturas_list.find(asignatura => asignatura.clase === filters.class_asignatura) || null;

        // Actualizar tema seleccionado
        this.selectedTema = this.temas_list.find(tema => tema.id === filters.tema) || null;
    }

    getTemas(): void {
        const filters = this._conf.getCurrentFilters();

        // Salir si no hay asignatura seleccionada
        if (!filters.asignatura) {
            this.temas_list = [];
            return;
        }

        // Obtener asignaturas originales y filtrar por grado si está disponible
        const asignaturasOriginales = this.dataLocal?.asignaturas || [];
        const asignaturasFiltradas = filters.grado
            ? asignaturasOriginales.filter(asignatura =>
                asignatura.g === filters.grado && asignatura.class === filters.class_asignatura
            )
            : asignaturasOriginales;

        // Agrupar asignaturas y encontrar la seleccionada
        const asignaturasList = agruparAsignaturas(asignaturasFiltradas);
        const selectedAsignatura = asignaturasList.find(asignatura =>
            asignatura.clase === filters.class_asignatura
        );

        // Reiniciar lista si no hay asignatura seleccionada
        if (!selectedAsignatura) {
            this.temas_list = [];
            return;
        }

        // Obtener temas y construir la lista
        const temasPorAsignatura = this.dataLocal?.temas;
        if (!temasPorAsignatura) {
            this.temas_list = [];
            return;
        }

        const temaMap = new Map<string, temaItem>();

        // Procesar todos los IDs de la asignatura seleccionada
        selectedAsignatura.listID.forEach(id => {
            const temas = temasPorAsignatura[id];
            if (temas?.length > 0) {
                temas.forEach(titulo => {
                    const cleanLabel = titulo.replace(/\$\$/g, '').trim();
                    if (!temaMap.has(cleanLabel)) {
                        temaMap.set(cleanLabel, {
                            label: cleanLabel,
                            id: titulo,
                            action: () => {
                                this._conf.updateFilterField(
                                    FILTER_LABEL_TEMA as keyof filterData,
                                    titulo ?? null
                                );
                            }
                        });
                    }
                });
            }
        });

        // Convertir Map a array ordenado
        this.temas_list = Array.from(temaMap.values())
            .sort((a, b) => a.label.localeCompare(b.label));
    }

    onGrados() {
        // console.debug('Grados Component Initialized dataGrados', this.dataGrados);
        this.grados_list = [];

        if (this.dataLocal?.grados) {
            this.grados_list = this.dataLocal.grados.map((grado) => {
                return {
                    id: grado.i,
                    label: grado.n,
                    icon: null,
                    clase: grado.class,
                    title: grado.n,
                    action: () => {
                        if (grado.i) {
                            this._conf.updateFilterField(FILTER_LABEL_GRADO as keyof filterData, grado.i ?? null);
                        }
                    }
                } as GradoItem;
            });


            //lista de grados en los que puede aparecer la asignatura seleccionada
            let asignaturas_list = agruparAsignaturas(this.dataLocal?.asignaturas || []);

            const tempAsignatura = asignaturas_list.find(asignatura =>
                asignatura.clase === this.selectedAsignatura?.clase
            );

            // console.debug('Grados Component tempAsignatura', tempAsignatura);

            if (tempAsignatura) {
                this.grados_list = this.grados_list.filter(grado => tempAsignatura.listGrados?.includes(grado.id ?? 0));
            }
        }
    }

    onAsignaturas() {
        this.asignaturas_list = agruparAsignaturas(this.dataLocal?.asignaturas || []);

        this.asignaturas_list.map((asignatura, index) => {
            asignatura.icon = this._icon_asignatura.getIconByCssId(asignatura.clase ?? 'd_asig_def');
            asignatura.action = () => {
                this._conf.updateFilterField(FILTER_LABEL_CLASS_ASIGNATURA as keyof filterData, asignatura.clase ?? null);
            }
        });

        //filtrar las asignaturas que pueden aparecer dependiendo el grado seleccionado
        if (this.selectedGrado?.id) {
            this.asignaturas_list = this.asignaturas_list.filter(asignatura =>
                asignatura.listGrados?.includes(this.selectedGrado?.id ?? 0)
            );
        }
    }

    onHome() {
        this._conf.ongetHome();
    }

    private searchfilter: string = 'd_overlaycontegrl_searchfilter';
    private searchcontainer: string = 'd_overlaycontegrl_search_cont';

    openSearch() {
        onRemoveClass(this.searchfilter, 'onShow');
        toggleClass(this.searchcontainer, 'onShow');
    }

    openFilter() {
        onRemoveClass(this.searchcontainer, 'onShow');
        toggleClass(this.searchfilter, 'onShow');
    }

    /**
     * Maneja el cambio de asignatura seleccionada
     */
    onAsignaturaChange(): void {
        if (this.selectedAsignatura?.action && typeof this.selectedAsignatura.action === 'function') {
            this.selectedAsignatura.action();
        }
    }

    /**
     * Maneja el cambio de grado seleccionado
     */
    onGradoChange(): void {
        if (this.selectedGrado?.action && typeof this.selectedGrado.action === 'function') {
            this.selectedGrado.action();
        }
    }

    /**
     * Maneja el cambio de tema seleccionado
     */
    onTemaChange(): void {
        if (this.selectedTema?.action && typeof this.selectedTema.action === 'function') {
            console.debug('Tema seleccionado:', this.selectedTema);
            this.selectedTema.action();
        } else {
            this._conf.updateFilterField(
                FILTER_LABEL_TEMA as keyof filterData,
                null
            );
        }
    }

    onClearFilters() {
        this.selectedCategories = [];
        this._conf.updateFilterField(
            FILTER_LABEL_CATEGORIA as keyof filterData,
            []
        );
    }

    onSearch() {
        // Lógica para manejar la búsqueda
        if (this.searchTerm.trim() === '') {
            this.tempAplicaciones = [];
        } else {
            this.tempAplicaciones = this.dataAplicaciones.filter(app =>
                app.n.toLowerCase().includes(this.searchTerm.toLowerCase())
            );
        }
    }

    highlightMatch(text: string): SafeHtml {
        if (!this.searchTerm || !this.searchTerm.trim()) {
            return text; // No modificar si es vacío o espacios
        }

        // Escapar caracteres especiales del término de búsqueda
        const escapedTerm = this.searchTerm.trim().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        const regex = new RegExp(`(${escapedTerm})`, 'gi');

        // Reemplazar coincidencias preservando exactamente el texto coincidente
        const highlighted = text.replace(regex, '<b>$1</b>');
        console.debug('highlighted', highlighted);
        return this.sanitizer.bypassSecurityTrustHtml(highlighted);
    }

    get existenDatos(): boolean {
        return (this._conf.dataGlobal?.asignaturas?.length ?? 0) > 1
            || (this._conf.dataGlobal?.grados?.length ?? 0) > 1;
    }

    get viewAsignaturas(): boolean {
        return (this._conf.dataGlobal?.asignaturas?.length ?? 0) > 1;
    }

    get viewGrados(): boolean {
        return (this._conf.dataGlobal?.grados?.length ?? 0) > 1;
    }

    get viewTemas(): boolean {
        return !['lectura'].includes(environment.portal);
    }

}
